import type { CSSProperties } from "react";

interface Props {
  label: string;
  value: number;
  onChange: (value: number) => void;
  readout: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  style?: CSSProperties;
}

/** One labelled slider with a readout, the unit of every mixer section. */
export function FaderRow(props: Props) {
  const { label, value, onChange, readout, min = 0, max = 1, step = 0.01, disabled, style } = props;
  return (
    <div className="mixer-row" style={style}>
      <span className="label">{label}</span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        disabled={disabled}
      />
      <span className="readout">{readout}</span>
    </div>
  );
}

export const percent = (v: number): string => (v * 100).toFixed(0);
